import { useMemo } from "react";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope.ts";

export const useExtractEntityGroupsFromScope = () => {
  const { data: scopeData, isLoading, refetch } = useGetCurrentUserPermissionScope();
  const { scope, resources } = scopeData || {};

  const entityGroups = useMemo(() => {
    const entityGroupsData = resources?.entityGroups || {};

    return (scope?.entityGroupTree || [])
      .filter(({ entityGroupId }) => entityGroupId && entityGroupId in entityGroupsData)
      .map(({ entityGroupId }) => ({ ...entityGroupsData[entityGroupId as string] }));
  }, [scope?.entityGroupTree, resources?.entityGroups]);

  return {
    entityGroups,
    isLoading,
    refetch,
  };
};
